import { gql, useQuery } from '@apollo/client';

export const GET_VACANCY_BY_ID = gql`
  query getVacancyById($vacancyId: ObjectId!) {
    getVacancyById(vacancyId: $vacancyId) {
      _id
      createdBy
      responsiblePersonsIds
      responsiblePersons {
        _id
        profile {
          displayName
        }
      }
      headerImage {
        filename
        location
        key
      }
      company {
        _id
        name
        logoUrl
      }
      job {
        _id
        title
        questionnaireSettingsIds
      }
      jobLocation {
        _id
        jobId
        companyDepartmentId
        companyLocationId
        companyLocation {
          name
        }
      }
      department {
        _id
        name
      }
      status
      jobDescription
      skills {
        name
      }
    }
  }
`;

export const useGetVacancyById = (vacancyId?: string) => {
  const { data, loading, error } = useQuery(GET_VACANCY_BY_ID, {
    variables: {
      vacancyId,
    },
    skip: !vacancyId,
  });

  return {
    vacancy: data?.getVacancyById || {},
    loading,
    error,
  };
};
